module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notetemplate"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("买家须知")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_vm._l((_vm.notetemplatelist), function(item, index) {
    return _c('a-col', {
      key: index,
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "span": 8
      }
    }, [_c('a-card', {
      staticStyle: {
        "border-radius": "5px",
        "overflow": "hidden"
      },
      attrs: {
        "hoverable": ""
      }
    }, [_c('div', {
      staticStyle: {
        "height": "121px",
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.note_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.note_text))])]), _vm._v(" "), _c('template', {
      staticClass: "ant-card-actions",
      slot: "actions"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.edit(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.del(item)
        }
      }
    }, [_vm._v("删除")])])], 2)], 1)
  }), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('a-card', {
    staticStyle: {
      "border-radius": "5px",
      "overflow": "hidden"
    },
    attrs: {
      "hoverable": ""
    },
    on: {
      "click": _vm.creatnotice
    }
  }, [_c('div', {
    staticStyle: {
      "height": "167px",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "165px",
      "text-align": "center",
      "display": "block",
      "font-size": "18px"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v(" 新增模板")], 1)])])], 1)], 2)], 1)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": _vm.istitle,
      "visible": _vm.isvisible,
      "maskClosable": false,
      "width": 900
    },
    on: {
      "ok": function($event) {
        return _vm.onOk(_vm.tempnotice)
      },
      "cancel": _vm.onCancel
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "模板名称"
    },
    model: {
      value: (_vm.tempnotice.note_title),
      callback: function($$v) {
        _vm.$set(_vm.tempnotice, "note_title", $$v)
      },
      expression: "tempnotice.note_title"
    }
  }), _vm._v(" "), _c('a-divider', {
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('a-input', {
    attrs: {
      "type": "textarea",
      "rows": "4",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.tempnotice.note_text),
      callback: function($$v) {
        _vm.$set(_vm.tempnotice, "note_text", $$v)
      },
      expression: "tempnotice.note_text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "10px"
    }
  }, [_c('div', [_vm._v("模板代码:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("订单号:")]), _c('span', [_vm._v("{trade_number}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("发货产品名称:")]), _c('span', [_vm._v("{order_sku_title}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("物流单号:")]), _c('span', [_vm._v("{delivery_number}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("物流公司英文名:")]), _c('span', [_vm._v("{delivery_express_name}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("物流公司中文名:")]), _c('span', [_vm._v("{delivery_express_display}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("收件人手机号:")]), _c('span', [_vm._v("{trade_receiver_phone}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("收件人姓名:")]), _c('span', [_vm._v("{trade_receiver_name}")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-right": "15px"
    }
  }, [_c('span', [_vm._v("收货地址:")]), _c('span', [_vm._v("{trade_receiver_address}")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61edc22e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/ordermanagement/notetemplate/index.vue
// module id = 2382
// module chunks = 1